import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Clock, Truck, CheckCircle2, Plus } from 'lucide-react';
import { StatCard } from '@/components/ui/StatCard';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/lib/supabaseClient';
import ResellerLayout from './components/ResellerLayout';

export default function ResellerDashboard() {
  const { resellerProfile } = useAuth();
  const [counts, setCounts] = useState({ total: 0, inProgress: 0, shipped: 0, delivered: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!resellerProfile) return;
    let mounted = true;
    const partnerId = resellerProfile.id;
    Promise.all([
      supabase.from('core_orders').select('id', { count: 'exact', head: true }).eq('partner_id', partnerId),
      supabase.from('core_orders').select('id', { count: 'exact', head: true }).eq('partner_id', partnerId).in('status', ['placed', 'confirmed']),
      supabase.from('core_orders').select('id', { count: 'exact', head: true }).eq('partner_id', partnerId).in('status', ['shipped', 'dispatched']),
      supabase.from('core_orders').select('id', { count: 'exact', head: true }).eq('partner_id', partnerId).eq('status', 'delivered'),
    ]).then(([total, inProgress, shipped, delivered]) => {
      if (!mounted) return;
      setCounts({
        total: total.count ?? 0,
        inProgress: inProgress.count ?? 0,
        shipped: shipped.count ?? 0,
        delivered: delivered.count ?? 0,
      });
      setLoading(false);
    });
    return () => {
      mounted = false;
    };
  }, [resellerProfile]);

  return (
    <ResellerLayout title="Dashboard">
      <div className="space-y-5">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <StatCard label="Total Orders" value={loading ? '—' : counts.total} icon={<ShoppingBag className="w-4 h-4" />} accent="primary" />
          <StatCard label="In Progress" value={loading ? '—' : counts.inProgress} icon={<Clock className="w-4 h-4" />} accent="warning" />
          <StatCard label="Shipped" value={loading ? '—' : counts.shipped} icon={<Truck className="w-4 h-4" />} accent="info" />
          <StatCard label="Delivered" value={loading ? '—' : counts.delivered} icon={<CheckCircle2 className="w-4 h-4" />} accent="success" />
        </div>

        <div className="bg-white rounded-2xl border border-[#E8E8E6] p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h3 className="font-serif text-lg font-bold text-[#2A2A2A]">Ready to restock?</h3>
            <p className="text-sm text-[#8A8A8A] mt-1">Place a new order at your wholesale rate.</p>
          </div>
          <Link
            to="/reseller/order/new"
            className="inline-flex items-center gap-1.5 px-6 py-3 bg-[#7B1113] text-white text-xs tracking-[0.15em] uppercase rounded-full hover:bg-[#5C0D0F] transition-colors cursor-pointer flex-shrink-0"
          >
            <Plus className="w-3.5 h-3.5" /> Place Order
          </Link>
        </div>
      </div>
    </ResellerLayout>
  );
}
